import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { LoadingSkeleton } from '@/components/LoadingSkeleton';
const TemplateDesigner = lazy(() => import('@/components/designer/TemplateDesigner'));

/** AB#812 — one theme template on the canvas. `bp` is the blueprint key the theme page uses. */
export const Route = createFileRoute('/sites/$siteSlug/theme_/design')({
  component: DesignTemplate,
  validateSearch: (search: { bp?: unknown; path?: unknown }): { bp: string; path: string } => ({
    bp: typeof search.bp === 'string' ? search.bp : '',
    path: typeof search.path === 'string' ? search.path : '',
  }),
});

function DesignTemplate() {
  const { siteSlug } = Route.useParams();
  const { bp, path } = Route.useSearch();
  return (
    <Suspense fallback={<LoadingSkeleton />}>
      <TemplateDesigner key={`${siteSlug}:${bp}:${path}`} siteSlug={siteSlug} blueprintKey={bp} path={path} />
    </Suspense>
  );
}
